
export interface BlogPost {
  id?: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  tags: string[];
  author_id: string;
  author_name: string;
  created_at: string;
  updated_at?: string;
  is_published: boolean;
  is_affiliated: boolean;
  cover_image?: string;
}

export const blogsService = {
  async createBlogPost(blogPost: Omit<BlogPost, 'id' | 'created_at'>): Promise<string> {
    const data = await apiClient.post('/blogs', blogPost);
    return data.id as string;
  },

  // Obtener todos los blog posts publicados
  async getPublishedBlogPosts(): Promise<BlogPost[]> {
    const data = await apiClient.get('/blogs?published=true');
    return (data || []) as BlogPost[];
  },

  // Obtener blog posts de un usuario específico
  async getBlogPostsByUser(userId: string): Promise<BlogPost[]> {
    const data = await apiClient.get(`/blogs?authorId=${encodeURIComponent(userId)}`);
    return (data || []) as BlogPost[];
  },

  // Obtener un blog post específico
  async getBlogPost(blogId: string): Promise<BlogPost | null> {
    const data = await apiClient.get(`/blogs/${encodeURIComponent(blogId)}`);
    return (data || null) as BlogPost | null;
  },

  // Actualizar un blog post
  async updateBlogPost(blogId: string, updates: Partial<BlogPost>): Promise<void> {
    await apiClient.put(`/blogs/${encodeURIComponent(blogId)}`, updates);
  },

  // Eliminar un blog post
  async deleteBlogPost(blogId: string): Promise<void> {
    await apiClient.delete(`/blogs/${encodeURIComponent(blogId)}`);
  },

  // Publicar un blog post (para administradores)
  async publishBlogPost(blogId: string): Promise<void> {
    await apiClient.post(`/blogs/${encodeURIComponent(blogId)}/publish`);
  }
};
import { apiClient } from './apiClient';
